// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:45:07

export default {
  "id": "celebrity-spring-manicure-design",
  "slug": "celebrity-spring-manicure-design",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/9db0d3b51d19496d879b5895e76a8218-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/9db0d3b51d19496d879b5895e76a8218/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Celebrity Spring Manicure Design",
      "description": "Step into the glamour of ‘Celebrity Spring Manicure Design’! Explore a world of trendy nail art, vibrant colors, and chic designs. Join celebrities in setting the trend for spring nails. Elevate your style with creative manicures, from floral elegance to modern motifs. Immerse yourself in the art of nail fashion and transform your fingertips into a canvas of spring-inspired beauty. ",
      "instructions": "Left Mouse Button Click",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "cutedressup",
        "fashion",
        "girls",
        "manicure",
        "spring"
      ]
    },
    "zh-CN": {
      "title": "名人春季美甲设计",
      "description": "踏入“明星春季美甲设计”的璀璨世界！探索时尚美甲、鲜艳色彩和时尚设计的世界。与明星们一起设定春季指甲潮流。通过创意美甲提升你的风格，从花卉优雅到现代图案。沉浸于指甲时尚的艺术之中，将你的指尖变成春季灵感的美甲画布。",
      "instructions": "左鼠标按钮点击",
      "genres": [
        "装扮"
      ],
      "tags": [
        "可爱装扮",
        "时尚",
        "女孩",
        "美甲",
        "春季"
      ]
    },
    "zh-TW": {
      "title": "名人春季美甲設計",
      "description": "步入「名人春季美甲設計」的華麗世界中！探索時尚美甲、鮮豔色彩與時尚設計的世界。與名人一起設立春季指甲的潮流。透過創意美甲提升你的風格，從花卉典雅到現代圖案。沉浸於指甲時尚的藝術中，將你的指尖轉變為春日啟發的美的畫布。",
      "instructions": "左鍵點擊",
      "genres": [
        "裝飾服裝"
      ],
      "tags": [
        "可愛裝扮",
        "時尚",
        "女孩",
        "美甲",
        "春季"
      ]
    },
    "zh-HK": {
      "title": "名人春季美甲設計",
      "description": "踏入「名人春季美甲設計」的時尚魅力！探索時尚美甲、豐富色彩及時尚設計的世界。與名人一起設定春季指甲的潮流。透過創意美甲提升你個人風格，從花卉雅致到現代主題。沉浸於指甲時尚的藝術之中，將你的指尖變成春天啟發的美的畫布。",
      "instructions": "左鍵按鈕點擊",
      "genres": [
        "打扮"
      ],
      "tags": [
        "可愛打扮",
        "時裝",
        "女兒",
        "美甲",
        "春天"
      ]
    },
    "ja": {
      "title": "セレブ春ネイルデザイン",
      "description": "‘セレブ春ネイルデザイン’のグラマーに足を踏み入れて！トレンディなネイルアート、鮮やかな色、洗練されたデザインの世界を探求しましょう。セレブたちと共に春のネイルトレンドを設定しましょう。花のエレガンスからモダンのモチーフまで、創造的なマニキュアであなたのスタイルを高めましょう。ネイルファッションの芸術に没頭し、あなたの手先を春にインスパイアされた美しいキャンバスに変えてみましょう。",
      "instructions": "左マウスボタンクリック",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "カワイイドレスアップ",
        "ファッション",
        "ガールズ",
        "マニキュア",
        "春"
      ]
    },
    "ko": {
      "title": "명성 봄 만니큐 디자인",
      "description": "'스타 스프링 만니큐 디자인'의 장막 속으로 들어가세요! 트렌디한 널리 아트, 다채로운 색상, 고급스러운 디자인의 세계를 탐험하세요. 스프링 널리의 트렌드를 설정하는 스타들과 함께하세요. 꽃무늬 고급스러움에서 현대적인 모티프까지 창의적인 만니큐로 스타일을 한 단계 업그레이드하세요. 널리 패션의 예술에 몰입하고, 손가락 끝을 봄을 영감으로 한 아름다움의 캔버스로 변신하세요.",
      "instructions": "왼쪽 마우스 버튼 클릭",
      "genres": [
        "드레스업"
      ],
      "tags": [
        "쿠트드레스업",
        "패션",
        "소녀",
        "만니쿠어",
        "봄"
      ]
    },
    "fr": {
      "title": "Design de manucure printanière des célébrités",
      "description": "Passez à la gloire de ‘Celebrity Spring Manicure Design’ ! Explorez un monde de nail art tendance, de couleurs vives et de designs élégants. Rejoignez les célébrités pour définir la tendance des ongles printanières. Elevez votre style avec des manucures créatives, allant de l'élégance florale aux motifs modernes. Immergez-vous dans l'art de la mode des ongles et transformez vos doigts en un tableau de beauté inspiré du printemps.",
      "instructions": "Clic gauche de la souris",
      "genres": [
        "Vêtements de rôle"
      ],
      "tags": [
        "cutedressup",
        "mode",
        "filles",
        "manucure",
        "printemps"
      ]
    }
  }
};
